import React, { useEffect, useState } from 'react';

import { productApi } from 'api/product';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'shadcn/components/ui/Tabs';
import { UnderConstruction } from 'shared';

import { HistoricalTab } from './shrinkLog/HistoricalTab';
import { PendingTab } from './shrinkLog/PendingTab';

function ShrinkLog() {
    const [featureFlagEnabled, setFeatureFlagEnabled] = useState(false);

    const setFeatureFlag = async () => {
        const response = await productApi.getIsFeatureOn('BULK_SHRINK_LOG');
        if (response.status) {
            if (response.data.isFeatureOn) {
                setFeatureFlagEnabled(true);
            }
        }
    };

    useEffect(() => {
        setFeatureFlag();
    }, []);

    return (
        <div className="h-full overflow-x-auto">
            {!featureFlagEnabled ? (
                <UnderConstruction />
            ) : (
                <Tabs defaultValue="pending" className="w-full h-full">
                    <TabsList className="w-full flex bg-gray-100 border border-gray-300 rounded-lg sticky top-0 z-10">
                        <TabsTrigger value="pending" className="flex-1">
                            Pending Approval
                        </TabsTrigger>
                        <TabsTrigger value="historical" className="flex-1">
                            Historical Log
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="pending">
                        <PendingTab />
                    </TabsContent>
                    <TabsContent value="historical">
                        <HistoricalTab />
                    </TabsContent>
                </Tabs>
            )}
        </div>
    );
}

export { ShrinkLog };
